// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 3a9 9 0 100 18 9 9 0 000-18zm3.214 10.286H8.786a1.285 1.285 0 110-2.572h6.428a1.285 1.285 0 110 2.572z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;